import React from 'react';
import { SvgUse } from './svg-icon.jsx';

const DEFAULT_BODY_COLOR = '#10AEE5';
const DEFAULT_WHEEL_COLOR = '#00121F';

export default function AngkasScooterIcon({
  className = '',
  width = 25,
  height = 16,
  title = 'ANGKAS',
  bodyColor = DEFAULT_BODY_COLOR,
  wheelColor = DEFAULT_WHEEL_COLOR,
  ...props
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 25 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      role="img"
      aria-label={title}
      {...props}>
      <g style={{ color: bodyColor }}>
        <SvgUse name="scooter-body" />
      </g>
      <g style={{ color: wheelColor }}>
        <SvgUse name="scooter-wheel" />
      </g>
    </svg>
  );
}
